import { render, staticRenderFns } from "./RmrTextarea.vue?vue&type=template&id=729315c8&scoped=true&"
import script from "./RmrTextarea.vue?vue&type=script&lang=js&"
export * from "./RmrTextarea.vue?vue&type=script&lang=js&"
import style0 from "./RmrTextarea.vue?vue&type=style&index=0&id=729315c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729315c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
